

import { call, put } from "redux-saga/effects";
import { API_URLS } from "../../../config";
import { CallApi } from "./api/callApi";
import { storeUserLogs } from "../../redux/slices/logsSlice";

export function* fetchUserLogsSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.LOGS.USER_DISABLED_LOGS, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeUserLogs(resp?.data?.data))
            action && action.callbackSuccess && action.callbackSuccess(resp?.data);
        } else {
            action && action.callbackError && action.callbackError(resp?.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
    }
}
